module.exports = __webpack_public_path__ + "img/fr.2e852fb4.png";